/**
 * PurchaseOrdersPage — the purchase-orders list, converged onto the shared
 * resource framework (#1420). The former 415-line bespoke page is now a thin
 * wrapper over `ResourcePage` + `purchaseOrderResource`; everything row-scoped
 * (status/supplier filtering, the detail drawer, the submit/cancel/close/
 * receive actions, the line-items card) lives in the resource definition.
 *
 * The resource is built IN-COMPONENT so its transition action captures the
 * page's mutation callback and the receive handoff captures `navigate`.
 */
import { ResourcePage } from '@resource-kit/ui/react';
import { NavGroupTabs } from '@components/layout/NavGroupTabs';
import { usePurchaseOrderResource } from './purchaseOrderResource';

export function PurchaseOrdersPage() {
  const resource = usePurchaseOrderResource();
  return (
    <ResourcePage
      bundle={{
        ...resource,
        host: {
          ...resource.host,
          listTabs: () => <NavGroupTabs group="procurementSuppliers" />,
        },
      }}
    />
  );
}

export default PurchaseOrdersPage;
